import { render, staticRenderFns } from "./EmptyImportFile.vue?vue&type=template&id=fa08d4b2&scoped=true"
import script from "./EmptyImportFile.vue?vue&type=script&lang=js"
export * from "./EmptyImportFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa08d4b2",
  null
  
)

export default component.exports